module.exports = __webpack_public_path__ + "24ef1edcdedd55e447c0d77d2da30885.svg";